/* ---------------------------------------------------------------------------
   bb-filter-ux.js --- filter panel UX: the per-section summary lines, live
   product counts, the no-matches state, "Clear all" in the sheet header, and
   standing the Zendesk launcher down while the sheet is open.

   MOVED OUT OF snippets/collection-filter-concept-body.liquid, where it was an
   inline <script>. That snippet is rendered TWICE per page (desktop sidebar +
   mobile bottom sheet) and both copies land BEFORE #CollectionLoop, so the
   browser parsed and compiled 6.2KB of identical script twice over --- halting
   the HTML parser each time --- before reaching a single product card. The
   __bbFilterUxInit guard made the second copy a no-op at RUNTIME, but the
   parse cost was paid regardless.

   Loaded once now, from the document head, with defer: fetched in parallel
   with the HTML, executed after parsing, blocking nothing.

   NOTE: `defer` only has an effect on a script with a src. It is IGNORED on an
   inline <script>. That is why this had to become a file rather than simply
   gaining the attribute.

   Behaviour is unchanged. This is the same code, relocated.
   --------------------------------------------------------------------------- */

(function(){
  if (window.__bbFilterUxInit) return;
  window.__bbFilterUxInit = true;

  var SHEET_OPEN_CLASS = 'bb-cf-sheet-open';

  function start(){
    var grid = document.getElementById('CollectionLoop');
    if (!grid || !grid.parentNode) return;

    var sheet = document.querySelector('[data-bb-cf-sheet]');
    var backdrop = document.querySelector('[data-bb-cf-backdrop]');

    /* ---------------------------------------------------------- empty state */
    var box = document.createElement('div');
    box.className = 'bb-cf-no-matches';
    box.setAttribute('data-bb-no-matches', '');
    box.innerHTML =
      '<p class="bb-cf-no-matches__title">Nothing here matches.</p>' +
      '<p class="bb-cf-no-matches__body">Remove a filter to see more, or give us a ring on ' +
      '<a href="tel:01886888873">01886&nbsp;888873</a> &mdash; we fit boots over the phone every day.</p>' +
      '<button type="button" class="bb-cf-no-matches__clear">Clear all filters</button>';
    grid.parentNode.insertBefore(box, grid.nextSibling);

    /* ------------------------------------------------- clear all, in header */
    var clearAll = null;
    var head = document.querySelector('.bb-cf-sheet-head');
    if (head) {
      var closeBtn = head.querySelector('[data-bb-cf-close]');
      var actions = document.createElement('div');
      actions.className = 'bb-cf-sheet-head__actions';
      clearAll = document.createElement('button');
      clearAll.type = 'button';
      clearAll.className = 'bb-cf-clear-all';
      clearAll.textContent = 'Clear all';
      clearAll.hidden = true;
      actions.appendChild(clearAll);
      if (closeBtn) actions.appendChild(closeBtn);
      head.appendChild(actions);
    }

    function visibleCount(){
      var items = grid.querySelectorAll('.product-item');
      var n = 0;
      Array.prototype.forEach.call(items, function(i){ if (i.style.display !== 'none') n++; });
      return n;
    }

    function selectedIn(section){
      var names = [];
      section.querySelectorAll('.is-sel').forEach(function(el){
        if (el.classList.contains('bb-cf-swatch')) names.push(el.getAttribute('aria-label'));
        else names.push(el.textContent.trim());
      });
      section.querySelectorAll('input[type="checkbox"]:checked').forEach(function(el){
        var s = el.parentElement.querySelector('span');
        if (s) names.push(s.textContent.trim());
      });
      return names;
    }

    function anySelected(){
      return !!(document.querySelector('.bb-cf-panel .is-sel') ||
                document.querySelector('.bb-cf-panel input[type="checkbox"]:checked'));
    }

    /* Summaries let a collapsed section still report its own state, so the
       whole filter is legible without opening anything. */
    function paint(){
      document.querySelectorAll('.bb-cf-panel .bb-cf-section').forEach(function(section){
        var labelSpan = section.querySelector('.bb-cf-head > span');
        if (!labelSpan) return;
        var sum = labelSpan.querySelector('.bb-cf-sum');
        if (!sum) {
          sum = document.createElement('span');
          sum.className = 'bb-cf-sum';
          labelSpan.appendChild(sum);
        }
        var names = selectedIn(section);
        sum.textContent = names.length ? names.join(', ') : '';
      });

      var n = visibleCount();
      document.querySelectorAll('[data-filter-apply]').forEach(function(btn){
        btn.textContent = 'Show ' + n + (n === 1 ? ' product' : ' products');
      });

      if (clearAll) clearAll.hidden = !anySelected();

      var chips = document.querySelector('[data-filter-chips]');
      var filtering = !!(chips && !chips.hidden && chips.children.length);
      box.classList.toggle('is-shown', n === 0 && filtering);
    }

    /* Runs the section's own Apply pipeline without letting it close the
       sheet, so results and counts update as controls are tapped. The class
       is restored in the same task, before paint, so there is no flicker. */
    function runApply(panel){
      var wasOpen = sheet && sheet.classList.contains('is-open');
      var btn = panel.querySelector('[data-filter-apply]');
      if (btn) btn.click();
      if (wasOpen && sheet) {
        sheet.classList.add('is-open');
        if (backdrop) backdrop.classList.add('is-open');
      }
    }

    document.querySelectorAll('.bb-cf-panel').forEach(function(panel){
      panel.addEventListener('click', function(ev){
        var t = ev.target.closest('.bb-cf-swatch, .bb-cf-pill, .bb-cf-check');
        if (!t) return;
        setTimeout(function(){ runApply(panel); paint(); }, 0);
      });
    });

    function clearEverything(){
      document.querySelectorAll('.bb-cf-panel').forEach(function(panel){
        panel.querySelectorAll('.is-sel').forEach(function(el){ el.classList.remove('is-sel'); });
        panel.querySelectorAll('input[type="checkbox"]').forEach(function(el){ el.checked = false; });
        var calf = panel.querySelector('[data-calf-section]');
        if (calf) calf.style.display = 'none';
      });
      var apply = document.querySelector('[data-filter-apply]');
      if (apply) apply.click();
      paint();
    }

    if (clearAll) clearAll.addEventListener('click', clearEverything);
    box.querySelector('.bb-cf-no-matches__clear').addEventListener('click', function(){
      clearEverything();
      window.scrollTo({ top: grid.offsetTop - 120, behavior: 'smooth' });
    });

    /* Chat launcher and scroll-top button both outrank the sheet on z-index
       and land on the Apply bar, so they step aside while it is open. */
    if (sheet && 'MutationObserver' in window) {
      new MutationObserver(function(){
        document.documentElement.classList.toggle(SHEET_OPEN_CLASS, sheet.classList.contains('is-open'));
      }).observe(sheet, { attributes: true, attributeFilter: ['class'] });
    }

    if ('MutationObserver' in window) {
      new MutationObserver(paint).observe(grid, {
        childList: true, subtree: true, attributes: true, attributeFilter: ['style']
      });
    }

    paint();
  }

  /* Run AFTER the first paint, not on DOMContentLoaded.

     start() walks every product card to build the counts and the summary
     lines. On a 114-product collection that is real main-thread work, and on
     DOMContentLoaded it runs BEFORE the browser has painted anything --- the
     shopper waits on it for no benefit, because none of what it produces is
     visible yet.

     requestAnimationFrame fires just before the next paint; the setTimeout
     inside it pushes the work to just after that paint has happened. So the
     page appears first and the panel fills in a frame later. */
  function boot(){
    var done = false;
    function go(){ if (done) { return; } done = true; start(); }

    /* rAF fires just before the next paint, so the setTimeout inside it lands
       just after the page has painted --- which is the point.

       But requestAnimationFrame DOES NOT FIRE IN A BACKGROUND TAB. A shopper
       who middle-clicks a collection into a new tab would get a panel with no
       counts, no summaries and no empty state until they focused it. So the
       timeout below is a real failsafe, not decoration: whichever fires first
       wins, and `done` keeps start() to exactly one run. */
    if (window.requestAnimationFrame) {
      requestAnimationFrame(function(){ setTimeout(go, 0); });
    }
    setTimeout(go, 300);
  }

  /* ---------------------------------------------------------------------
     STAGED REVEAL --- holds the desktop filter sidebar until the products
     have painted, then fades it in.

     Lives here, not in the collection section: this file is already loaded
     once with defer, and that section is 44KB which has never been edited and
     is better left that way.

     The matching CSS is in snippets/bb-filter-ux-css.liquid, in the head, so
     the rule holding the sidebar back reaches the browser long before the
     sidebar does. That ordering is the entire point --- the earlier attempt
     put it in the section's own stylesheet, which is emitted after the grid.

     Three ways to reveal, because a filter that never appears is far worse
     than one that appears slightly early:
       1. the first row of product images has settled (the real signal)
       2. window load
       3. a ceiling timer, purely a "something is broken" guard
     ------------------------------------------------------------------ */
  function stageReveal(){
    var section = document.querySelector('section[id^="Collection--"]');
    if (!section) { return; }

    var revealed = false;
    function reveal(){
      if (revealed) { return; }
      revealed = true;
      section.classList.add('bb-cf-revealed');
    }

    var ceiling = setTimeout(reveal, 15000);
    window.addEventListener('load', function(){ setTimeout(reveal, 200); });

    var grid = document.getElementById('CollectionLoop');
    if (!grid) { reveal(); return; }

    /* One row at THIS width: the desktop grid is 4 up, the phone 2. */
    var perRow = window.matchMedia('(max-width: 749px)').matches ? 2 : 4;
    var imgs = [];
    Array.prototype.slice.call(grid.querySelectorAll('.product-item'), 0, perRow).forEach(function(item){
      var img = item.querySelector('[data-product-image-default] img');
      if (img) { imgs.push(img); }
    });
    if (!imgs.length) { setTimeout(reveal, 200); return; }

    var pending = imgs.length;
    function settled(){
      pending -= 1;
      if (pending > 0) { return; }
      setTimeout(function(){ clearTimeout(ceiling); reveal(); }, 200);
    }
    imgs.forEach(function(img){
      if (img.complete) { settled(); return; }
      img.addEventListener('load', settled, { once: true });
      img.addEventListener('error', settled, { once: true });
    });
  }
  stageReveal();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
